<template>
  <el-dialog
    :title="title"
    :visible.sync="isOpen"
    width="90%"
    append-to-body
    :close-on-click-modal="false"
    :footer="null"
  >
    <iframe :src="src" class="view-box" />
  </el-dialog>
</template>

<script>
import { getFile } from "@/api/file.js";
import { fileDownload } from "@/utils/index.js"
export default {
  data() {
    return {
      isOpen: false,
      src: "",
      title: ""
    };
  },
  methods: {
    open({ name }) {
      // this.src = process.env.VUE_APP_BASE_API + '/file?filename=' + name;
      this.getFile(name);
      // this.title = title;
      this.isOpen = true;
    },
    close() {
      this.viewSrc = "";
      this.isOpen = false;
    },
    getFile(name) {
      getFile({ filename: name }).then(res => {
        let changeUrl = "";
        let file = new Blob([res.data], { type: "application/pdf" });
        if (window.createObjectURL !== undefined) {
          // basic
          changeUrl = window.createObjectURL(file);
        } else if (window.webkitURL !== undefined) {
          // webkit or chrome
          try {
            changeUrl = window.webkitURL.createObjectURL(file);
          } catch (error) {}
        } else if (window.URL !== undefined) {
          // Mozilla (firefox)
          try {
            changeUrl = window.URL.createObjectURL(file);
          } catch (error) {}
        }

        this.src = changeUrl;
      });
    }
  }
};
</script>
<style scoped>
.view-box {
  width: 100%;
  height: calc(100vh - 2.4rem);
  border: none;
}
</style>
